import { css } from '@emotion/react';
import { tokens } from '@flysas-tech/commercial-ui';
import { PropsWithChildren } from 'react';

const styles = css`
  width: 100%;
  border-radius: ${tokens.cornerRadius.large};
`;

type ImageProps = {
  src: string;
  alt: string;
  className?: string;
};

export const Image = ({ src, alt, className }: PropsWithChildren<ImageProps>) => (
  <img css={styles} className={className} src={src} alt={alt} />
);
